const toObject = (object, entity) => Object.assign({}, object, entity);

const toObjectById = (object, entity) => Object.assign({}, object, { [entity.id]: { ...entity } });

// lift attributes data to top-level & include relationships is present
const flatten = (entity) =>
  Object.assign(
    {
      id: entity.id,
      type: entity.type,
    },
    entity.links ? { links: entity.links } : {},
    entity.relationships ? { relationships: entity.relationships } : {},
    entity.attributes,
  );

const groupByType = (object, entity) => {
  // pluralise the type for the key
  const key = `${entity.type}s`;
  const value = object[key] || [];
  return Object.assign(object, { [key]: value.concat(flatten(entity)) });
};

const byId = (object) => (key) => ({ [key]: object[key].reduce(toObjectById, {}) });

const groupByTypeAndId = (array) => {
  const groupedByType = array.reduce(groupByType, {});
  return Object.keys(groupedByType)
    .map(byId(groupedByType))
    .reduce(toObject, {});
};

let buildRelationships;

// replace relationship reference with data from the map of included data
const resolveRelationships = (mapOfRelationshipData, entity) => {
  const relationships = Object.keys(entity.relationships)
    .map((relation) => ({
      [relation]: entity.relationships[relation].data
        // It's invalid JSON API but we've seen items in `data` reference a type
        // missing from `included`. Be defensive and ignore. See test for example
        .map((data) => {
          const resource = (mapOfRelationshipData[relation] || {})[data.id];

          if (resource) {
            return buildRelationships(mapOfRelationshipData, resource);
          }

          return resource;
        })
        // filter out false-y values from the missing relation data issue (above)
        .filter(Boolean),
    }))
    .reduce(toObject, {});

  const result = Object.assign({}, entity, relationships);

  if ('relationships' in result) {
    delete result.relationships;
  }

  return result;
};

buildRelationships = (mapOfRelationshipData, entity) =>
  entity.relationships ? resolveRelationships(mapOfRelationshipData, entity) : entity;

export default function(response) {
  const responseKeys = Object.keys(response);

  // this isn't a JSONAPI response, so pass through
  if (responseKeys.indexOf('data') === -1) {
    return response;
  }

  // group included data by type and id
  const includeMap =
    response.included && response.included.length ? groupByTypeAndId(response.included) : {};

  const denormalizedData =
    response.data.length === undefined
      ? flatten(response.data)
      : response.data.map((entity) => {
          const flatEntity = flatten(entity);
          return buildRelationships(includeMap, flatEntity);
        });

  return {
    status: response.status,
    links: response.links,
    meta: response.meta,
    data: denormalizedData,
  };
}
